// Axios
import axios from "axios";

// Toast
import { toast } from 'react-toastify';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

// Stores
import AuthStore from '../mobx/stores/AuthStore';
import LanguageStore from '../mobx/stores/LanguageStore';
import ShoppingCartStore from '../mobx/stores/ShoppingCartStore';

const logout = async () => {
    localStorage.removeItem('userData');

    setUserData({
        isLogin: false
    })

    window.location.href = '/home'
}

const loginControl = async () => {
    try {
        let response: any = localStorage.getItem('userData');

        if (response !== null) {
            response = JSON.parse(response);

            await login(response);
        }

        return true;
    } catch (error) {
        console.log(error);
    }
}

const login = async (userData: any, props?: any) => {
    try {
        const loginUserData = {
            username: userData.username,
            password: userData.password,
        };

        const response = await axios.post(`${Config.App.apiUrl}/auth/customLogin`, {
            ...userData,
            language: LanguageStore.languageData.currentLanguage
        });

        if (response.data.status === true) {
            const userData = response.data.data;
            const userFirstData = response.data.firstData;

            setUserData({
                isLogin: true,
                id: userData.id,
                username: userData.username,
                name_surname: userData.name_surname,
                email: userData.email,
                token: userData.token,
                language: LanguageStore.languageData.currentLanguage,
                dealer: userData.dealer !== null ? userData.dealer : 0,
                stores: userData.stores,
                currency: userData.currency,
                discount_amount: userData.discount_amount,
                discounted_products: userData.discounted_products,
                discounted_product_datas: userData.discounted_product_datas
            });

            localStorage.setItem('userData', JSON.stringify(loginUserData));

            // First Data
            await Promise.all(userFirstData.shoppingCart.data.map(async (shoppingCart: any) => {
                if (shoppingCart.attributes.product.data !== null) {
                    if (ShoppingCartStore[shoppingCart.id] === undefined) {
                        ShoppingCartStore.addShoppingCart(shoppingCart.id, {
                            id: shoppingCart.id,
                            product_id: shoppingCart.attributes.product.data.id,
                            ...shoppingCart.attributes
                        })
                    }
                }
            }));
            // First Data

            if (props !== undefined) {
                setTimeout(() => {
                    props.navigate('/')
                }, 500)
            }

            return true;
        } else {
            localStorage.removeItem('userData');

            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const getUserData = () => {
    return AuthStore.userData;
}

const setUserData = (data: any) => {
    AuthStore.setUserData({
        ...AuthStore.userData,
        ...data,
    })
}

const passwordChange = async (values: any) => {
    try {
        const response = await axios.put(`${Config.App.apiUrl}/auth/updatePassword`,
            {
                ...values
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                },
            }
        );

        if (response.data.status === true) {
            toast(Helpers.translation(response.data.message));

            let userData: any = localStorage.getItem('userData');
            userData = JSON.parse(userData);

            localStorage.setItem('userData', JSON.stringify({
                ...userData,
                password: values.new_password
            }));
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        return response.data;
    } catch (error) {
        console.log('passwordChange:', error);
    }
}

const updatePersonalSettings = async (values: any) => {
    try {
        const response = await axios.put(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.updatePersonalSettings}`,
            {
                data: {
                    ...values,
                }
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`
                }
            }
        );

        if (response.data.status) {
            setUserData({
                ...values
            })

            let userData: any = localStorage.getItem('userData');
            userData = JSON.parse(userData);
            localStorage.setItem('userData', JSON.stringify({
                ...userData,
                username: values.username
            }));

            toast(Helpers.translation(response.data.message));
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        return response.data;
    } catch (error) {
        console.log('updatePersonalSettings:', error);
    }
}

const exportHelpers = {
    loginControl,
    login,
    logout,
    getUserData,
    passwordChange,
    updatePersonalSettings
}

export default exportHelpers;